/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots8VIcon16Light = forwardRef('UiMenuDots8VIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { d: "M6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { d: "M7 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M6 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { d: "M10 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M9 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { d: "M10 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M9 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" })));
});
